package pl.decks.personal.components.widgets.hasdiagram

sealed class HASNodePosition {
    object Inner : HASNodePosition()
    data class Outer(val pos: Int) : HASNodePosition()
}
